export default __webpack_public_path__ + "18cccdbdd0ad456bd9fd9dd65c354be9.svg";